import React from "react"

import "./i18n.js"
import "./clear.css"

import { GlobalStyle } from "../components/Style"

export default ({ children }) => {
  return <GlobalStyle>{children}</GlobalStyle>
}
